module.exports = __webpack_public_path__ + "img/115.79272b00.jpg";